<div class="body">

    <div class="content">

        <ng-container *ngFor="let newsfeedNotification of newsfeedService.changeNotifications">

            <div class="newsfeed-notification-wrapper" (click)="newsfeedNotificationClicked(newsfeedNotification)">
    
                <app-newsfeed-notification [newsfeedNotification]="newsfeedNotification"></app-newsfeed-notification>
    
            </div>
    
        </ng-container>

        <ng-container *ngIf="autoRefresh$|async">

            <div class="overlay" (click)="reload()">

                <div>Automatischer Reload in {{refreshSeconds}} Sekunden</div>
                <div>Klicken um jetzt zu erneuern</div>

            </div>

        </ng-container>
    

    </div>

    <div class="footer">

        <ng-container *ngIf="initializing$|async; else ready">

            <mat-spinner [diameter]="40"></mat-spinner>

        </ng-container>

        <ng-template #ready>

            <div class="counter">
                {{newsfeedService.changeNotifications.length}} von {{newsfeedService.totalChangeNotificationCount$|async}}
            </div>
    
            <div class="load-more" (click)="reload()">
                Neu laden
            </div>
    
            <div class="load-more" (click)="loadMore()">
                Mehr laden
            </div>

        </ng-template>

    </div>

</div>